import VanillaDropdown from './vanillaDropdown.js'; //window.addEventListener(`load`, () => {
//    const dropdowns = document.querySelectorAll(`vanilla-dropdown`);
//    for (dropdown of dropdowns) {
//        const dropdown = new VanillaDropdown(dropdown);
//    }
//});